import { useState } from 'react';
import PreLoader from "./PreLoader";
import App from "../App";

const PreloadPage = () => {
    const [loading, setLoading] = useState(true);

    return (
        <>
            <App />
            {loading && <PreLoader onFinish={() => setLoading(false)} />}
        </>
    );
};

export default PreloadPage;
